import React, { Component } from 'react'
import *as s from './PinkModule.module.css'
import { StaticImage } from 'gatsby-plugin-image'
export default class PinkModule extends Component {
    render() {
        return (
            <div className={s.wrapper}>
                 <div className={s.container}>
                     <div className={s.submodule}>
                        <StaticImage src="../../../images/hand-big.svg" alt="information icon" className={s.icon}/>
                        <h2 >Hinweis</h2>
                     </div>
                     <p className={s.text}>
                         olgende informationsquellen und Anlaufstellen könnten - 
                         ohne Anspruch auf Vollständigkeit sowie ohne Gewähr - für Ihr Anliegen relevant sein.
                         Nach Anklicken eines Themas öffnet sich ein externer Link mit weiterführenden informationen in einem neuen Fenster.
                     </p>
                 </div>
             </div>
        )
    }
}
